import React, { type ReactNode } from "react";
import cx from "classnames";

import * as styles from "@/features/betslip/components/parts/BetCardHeader.module.scss";

type BetCardHeaderProps = {
  icon: ReactNode;
  title: string;
  subtitle?: string;
  clamp?: ReactNode;
  rightSlot?: ReactNode;
  isDeactivated?: boolean;
  testId?: string;
};

export const BetCardHeader = ({
  icon,
  title,
  subtitle,
  clamp,
  rightSlot,
  isDeactivated = false,
  testId,
}: BetCardHeaderProps) => (
  <div
    className={cx(styles.header, {
      [styles.deactivated]: isDeactivated,
    })}
    data-testid={testId}
  >
    <div className={styles.iconSlot}>{icon}</div>
    <div className={styles.text}>
      <p className={styles.title}>{title}</p>
      {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
    </div>
    {clamp ? <div className={styles.clamp}>{clamp}</div> : null}
    {rightSlot}
  </div>
);
